import { InputHTMLAttributes, useState } from "react";
import { FieldErrors, UseFormRegisterReturn } from "react-hook-form";
import { MdOutlineVisibility, MdOutlineVisibilityOff } from "react-icons/md";
import type { IconType } from "react-icons";

type InputFieldProps = {
  label?: string;
  subLabel?: string;
  hasRequiredLabel?: boolean;
  type: string;
  register?: UseFormRegisterReturn;
  errors?: FieldErrors<any>;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

const InputField = ({ label, subLabel, hasRequiredLabel = false, type, register, errors, ...restProps }: InputFieldProps) => {

  const [showPassword, setShowPassword] = useState(false);

  const inputType = type === 'password' ? (showPassword ? 'text' : 'password') : type;
  
  return (
    <div className="m-form-item">
      <div className="m-form-item__header">
        {label && <p className="m-form-item__caption">{label}{hasRequiredLabel && <span className="required">*</span>}</p>}
        {subLabel && <p className="m-form-item__sub-caption">{subLabel}</p>}
      </div>
      <div className="m-form-item__input">
        <div className="m-form-item__input__container">
          <input type={inputType} {...register} {...restProps} autoComplete={`new-${register?.name}`} />
          {type === 'password' && (
            <button type="button" className="suffix-button" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? 
                <MdOutlineVisibility size={20} aria-label="パスワードを隠す" /> : 
                <MdOutlineVisibilityOff size={20} aria-label="パスワードを表示" />
              }
            </button>
          )}
        </div>
        {(errors && register && errors[register.name]) && <p className="m-form-item__error">{String(errors[register.name]?.message || '入力エラー')}</p>}
      </div>
    </div>
  );
};

export default InputField;